"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Title = void 0;
var react_1 = __importDefault(require("react"));
var Title = function (_a) {
    var children = _a.children, className = _a.className, onClick = _a.onClick, type = _a.type;
    var classNameFromType = __spreadArray([
        'storybook-menus-dashboard-title'
    ], (type ? [type] : [])).join('-');
    return (react_1.default.createElement("h1", { className: classNameFromType, onClick: onClick }, children));
};
exports.Title = Title;
exports.Title.propTypes = {};
exports.Title.defaultProps = {
    type: ''
};
